OutboundNumberItemView = require('./item-view')

class OutboundNumberCollectionView extends Marionette.CollectionView
  childView: OutboundNumberItemView

module.exports = OutboundNumberCollectionView
